import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import teacherImage from '../assets/Ksenia foto sait.jpg'; // Используйте временное имя файла
import teacherImage2 from '../assets/ksenia 2 krayonika.jpg';
import './About.css';

function About() {
  return (
    <Container className="my-5">
      <Row className="align-items-center">
        <Col md={5}>
          <Row>
            <Col xs={6} className="text-center">
              <Image src={teacherImage} roundedCircle fluid className="about-image" />
            </Col>
            <Col xs={6} className="text-center">
              <Image src={teacherImage2} roundedCircle fluid className="about-image" />
            </Col>
          </Row>
        </Col>
        <Col md={7}>
          <h1 className="mb-4">О нашей студии</h1>
          <h4 className="text-muted mb-4">Место, где творчество оживает</h4>
          <p>
            Добро пожаловать в «Крайоника» — уютную студию, созданную с любовью к искусству и желанием делиться им с другими. Меня зовут Ksenia и я — основательница этой школы.
          </p>
          <h5 className="mt-4">Мой подход</h5>
          <p>
            Я верю, что рисовать может каждый, независимо от возраста и способностей. Моя главная задача — не просто научить техникам, а помочь каждому ученику найти свой уникальный художественный голос, раскрыть творческий потенциал и получать удовольствие от процесса. На занятиях царит дружелюбная и поддерживающая атмосфера, где нет места страху ошибки.
          </p>
          <h5 className="mt-4">Опыт и вдохновение</h5>
          <p>
            За моими плечами 20 лет опыта в архитектуре, и более 3 лет преподавания архитектуры, живописи и иллюстрации для детей и взрослых. Я постоянно учусь новому — сейчас на графический дизайнер! Постоянно черпаю вдохновение в работах великих мастеров, в природе, в детских книгах и, конечно же, в успехах моих учеников. Меня особенно увлекает создание объемных pop-up конструкций, которые превращают плоский рисунок в настоящую магию.
          </p>
          <h5 className="mt-4">Чему вы научитесь?</h5>
          <p>
            В нашей студии вы не просто освоите основы рисунка, композиции и цвета, но и научитесь мыслить креативно, переносить свои идеи на бумагу и создавать уникальные иллюстрации и даже собственные pop-up книги.
          </p>
          <p className="fw-bold">Присоединяйтесь к нам, и давайте творить вместе!</p>
        </Col>
      </Row>
    </Container>
  );
}

export default About;